module.exports = __webpack_public_path__ + "static/media/acd3c572-8f49-4aa1-acbc-4ab28162b385_1.21731ab71bbd45ddf30d3e4ff49ace6a.af81045a.jpeg";